
import React from 'react';

const WerftoolsLogo: React.FC<{ className?: string, color?: string }> = ({ className = "w-8 h-8", color = "#e51b23" }) => {
  return (
    <svg viewBox="0 0 400 300" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        d="M125 40V240H175V160C175 125 225 125 225 160V240H275V40H225V140C225 100 175 100 175 140V40H125Z" 
        fill={color}
      />
    </svg>
  );
};

export default WerftoolsLogo;
